import React, { useState } from "react";
import { ToastContainer } from "react-toastify";
import { FaSearch } from "react-icons/fa";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SESI from "../../assets/img/sesi.png";
import {
  AcceptButton,
  Container,
  Footer,
  Header,
  Input,
  InputGroup,
  SearchButton,
  Select,
  Table,
  Td,
  Th,
  Title,
  WrapContent,
} from "../../styles/History";
import AdesaoModel from "../../data/models/adesao";
import { getAdesaoListFiltered } from "../../data/services/enterprise_service";
import { acceptAdesao } from "../../data/provider/enterprise/api_enterprise";
import { GrRotateLeft } from "react-icons/gr";
import { BackButton } from "../../styles/AddAdherense";
import { HOME_LOGGED } from "../../core/app-urls";
import { useNavigate } from "react-router-dom";

export default function AdherenseHistory() {
  const [selectedAdesaoType, setSelectedAdesaoType] = useState<string>("");
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const [adesaoData, setAdesaoData] = useState<AdesaoModel[]>([]);

  const handleSearch = async () => {
    if (!selectedAdesaoType || !startDate || !endDate) {
      alert("Por favor, selecione o tipo de adesão e informe as datas.");
      return;
    }

    const filter = selectedAdesaoType === "Aprovadas" ? "S" : "N";

    try {
      const { data } = await getAdesaoListFiltered(
        localStorage.getItem("id")!,
        filter,
        startDate,
        endDate
      );

      console.log("Retorno da API:", data);

      setAdesaoData(data || []);
    } catch (error) {
      console.error("Erro ao buscar adesões:", error);
      setAdesaoData([]);
    }
  };

  const handleAccept = async (id: number) => {
    try {
      await acceptAdesao([id], "S", "");
      toast.success("Adesão aprovada com sucesso!", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      console.log("Sucesso");

      setAdesaoData((prevData) =>
        prevData.filter((adesao) => adesao.id !== id)
      );
    } catch (error) {
      toast.error("Erro ao aprovar adesão.");
    }
  };

  const navigate = useNavigate();

  const handleLogout = () => {
    navigate(HOME_LOGGED);
  };

  return (
    <Container>
      <WrapContent>
        <BackButton onClick={handleLogout}>VOLTAR</BackButton>
        <Header>
          <Title>Histórico de adesões</Title>
          <img src={SESI} alt="SESI Logo" width={80} />
        </Header>

        <h4>
          Selecione a data de início, fim e o tipo de adesão (aprovada ou
          reprovada).
        </h4>
        <InputGroup>
          <Input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <Input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
          <Select
            value={selectedAdesaoType}
            onChange={(e) => setSelectedAdesaoType(e.target.value)}
          >
            <option value="">Selecione o tipo</option>
            <option value="Aprovadas">Aprovadas</option>
            <option value="Reprovadas">Reprovadas</option>
          </Select>
          <SearchButton onClick={handleSearch}>
            <FaSearch color="white" />
          </SearchButton>
        </InputGroup>
        <div style={{ maxHeight: "400px", overflowY: "auto", width: "100%" }}>
          <Table>
            <thead>
              <tr>
                <Th>NOME</Th>
                <Th>CPF</Th>
                <Th>PLANO DE ADESÃO</Th>
                {selectedAdesaoType === "Reprovadas" && <Th>Motivo</Th>}
                {selectedAdesaoType === "Reprovadas" && <Th>Aprovar</Th>}
              </tr>
            </thead>
            <tbody>
              {adesaoData.length > 0 ? (
                adesaoData.map((adesao, index) => (
                  console.log("ADESAO:", adesao),
                  <tr key={index}>
                    <Td>{adesao.nome}</Td>
                    <Td>{adesao.cpf}</Td>
                    <Td>{adesao.categoria}</Td>
                    {selectedAdesaoType === "Reprovadas" && (
                      <Td>{adesao.motivo}</Td>
                    )}
                    {selectedAdesaoType === "Reprovadas" && (
                      <Td>
                        <AcceptButton>
                          <GrRotateLeft
                            size={34}
                            style={{
                              alignSelf: "center",
                              marginLeft: "5px",
                              cursor: "pointer",
                            }}
                            onClick={() => handleAccept(adesao.id)}
                          ></GrRotateLeft>
                        </AcceptButton>
                      </Td>
                    )}
                  </tr>
                ))
              ) : (
                <tr>
                  <Td
                    colSpan={selectedAdesaoType === "Reprovadas" ? 5 : 4}
                    style={{ textAlign: "center" }}
                  >
                    Nenhuma adesão encontrada.
                  </Td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
        <Footer>Developed by WBC SISTEMAS</Footer>
      </WrapContent>
      <ToastContainer />
    </Container>
  );
}
